module.exports = __webpack_public_path__ + "static/media/kiwi-picker-robotics.d562bca6.jpg";